import React, { useEffect } from 'react';
import bgImage from '../assets/img/bigstock-chart-background-203062333.jpg';
import { Helmet } from 'react-helmet';
import Header from '../comp/Header';

function Casosdeexito(props) {
  useEffect(() => {
    props.setBackgroundImage(bgImage);
  }, []);

  

  return (
    <div>
      <Helmet>
        <title>Enginios - Casos de éxito</title>
        <meta name="description" content= "Enginios ha trabajado en muchos proyectos, todos ellos desarrollados, con éxito, profesionalidad y gusto. Descúbrelos."/>
        <meta name="keywords" content="Enginios proyectos, Enginios casos de exito, Enginios referencias"/>
        <meta name="robots" content= "index, follow"/>
      </Helmet>
      <Header title="Casos de éxito" />
      <div className="mainBlank">
        <main>
          <p>Estos son algunos de los proyectos llevados a cabo por Enginios con éxito</p>
          <div class="proyTable"></div>
        </main>
      </div>
    </div>
    
  );
};

export default Casosdeexito